import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Board } from './Board'

export const ListOfBoardValidation = z.object({
  list: z.instanceof(Board, { message: '[ListOfBoard] list is required' }).array(),
})

// Board types allowed in search filters
export const SEARCH_FILTER_BOARD_TYPES = [
  'room-only',
  'breakfast',
  'all-inclusive',
  'half-board',
  'dinner',
  'lunch',
  'full-board',
  'buffet',
] as const

export type SearchFilterBoardType = (typeof SEARCH_FILTER_BOARD_TYPES)[number]

export class ListOfBoard extends Model {
  static readonly MAX_FEATURED = 5

  static create({ list }: z.infer<typeof ListOfBoardValidation>) {
    ListOfBoardValidation.parse({ list })
    return new ListOfBoard(list)
  }

  static fromJSON({ json }: { json: ReturnType<ListOfBoard['toJSON']> }) {
    return ListOfBoard.create({
      list: json.list.map(boardJSON => Board.fromJSON({ json: boardJSON })),
    })
  }

  static empty() {
    return new ListOfBoard([])
  }

  constructor(private readonly _list: Board[]) {
    super()
  }

  get list() {
    return this._list
  }

  getFeatured() {
    return this._list.slice(0, ListOfBoard.MAX_FEATURED)
  }

  getNonFeatured() {
    return this._list.slice(ListOfBoard.MAX_FEATURED)
  }

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  isEmpty() {
    return this._list.length === 0
  }

  map<T>(callback: (board: Board, index: number) => T) {
    return this._list.map(callback)
  }
}
